// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3ChwF","inputWrap":"CustomTip_inputWrap__3jp-Y"};